<template>
  <button
    id="JbPrimeServiceAttendantButton"
    class="JbPrimeServiceAttendantButton"
    @click="handleClick"
  >
    <BaseIcon :name="cptdIconName" size="md" />
  </button>
</template>

<script>
import { mapActions } from 'vuex'
import BaseIcon from '@/aasgard/components/base/BaseIcon.vue'
export default {
  name: 'JbPrimeServiceAttendantButton',
  components: {
    BaseIcon,
  },
  props: {
    subscribed: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['click'],
  computed: {
    cptdIconName() {
      if (!this.subscribed) return 'question-answer-lock-color'
      return 'question-answer-color'
    },
  },
  mounted() {
    this.actEmitGaEvent({
      eventCategory: 'jb-prime-service-attendant-floating-button',
      eventAction: 'button-displayed',
      eventLabel: 'button-displayed',
    })
  },
  methods: {
    ...mapActions({
      actEmitGaEvent: 'services/ga/actEmitGaEvent',
    }),
    handleClick() {
      this.actEmitGaEvent({
        eventCategory: 'jb-prime-service-attendant-floating-button',
        eventAction: this.subscribed ? 'prime-click' : 'free-click',
        eventLabel: location.pathname,
      })
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss">
.JbPrimeServiceAttendantButton {
  width: 64px;
  height: 64px;
  background-color: $color-brand-primary-light;
  border: none;
  box-shadow:
    0 0 2px rgba(0, 0, 0, 0.16),
    0 4px 8px rgba(0, 0, 0, 0.16);
  border-radius: 10000px;
  position: fixed;
  right: 16px;
  bottom: 80px;
  cursor: pointer;
  z-index: 10031;

  @include media(md) {
    right: 32px;
    bottom: 32px;
  }

  & > .BaseIcon {
    @include setSVGMonoColor($color-white-medium);
  }
}
</style>
